module.exports = __webpack_public_path__ + "img/icon-visa-dark.201a190a.png";